"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const thumbdown = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-thumbdown` : '') + (description ? ` desc-thumbdown` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-thumbdown"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-thumbdown"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7617 21.5951C13.132 21.5951 14.2473 20.5038 14.2861 19.1429L14.2871 19.0697L14.287 15.2856L20.4172 15.2855C21.1421 15.2844 21.8319 14.9793 22.32 14.4468L22.3776 14.3819C22.8493 13.8314 23.0674 13.1093 22.9817 12.392L22.97 12.3059L21.7223 4.19621C21.5332 2.95775 20.4852 2.03671 19.24 2.00107L19.1651 2L8.83438 2C8.26618 2.00084 7.70534 2.12432 7.18882 2.36205L7.07882 2.41474L6.109 2.90114L2.57151 2.90047C1.75181 2.90047 1.07868 3.52806 1.00642 4.32894L1 4.47198L1 12.8135C1 13.6815 1.70359 14.3851 2.57151 14.3851L5.855 14.3851L9.61962 20.4069C10.081 21.1456 10.8903 21.5946 11.7617 21.5951ZM11.7622 20.0236C11.4523 20.0234 11.163 19.873 10.9845 19.6223L10.9524 19.5742L7.077 13.3751L7.077 4.17314L7.78091 3.82069C8.0791 3.67218 8.40484 3.5882 8.73604 3.57375L8.83554 3.57151L19.1651 3.57151C19.6488 3.57151 20.0626 3.912 20.1595 4.38161L20.169 4.43431L21.4167 12.5447C21.4616 12.8372 21.3767 13.1347 21.1842 13.3594C21.0045 13.5691 20.7478 13.6959 20.4747 13.7122L20.416 13.714L13.5013 13.714C13.0829 13.714 12.7408 14.0411 12.7169 14.4536L12.7156 14.4998V19.0697C12.7156 19.5966 12.2885 20.0236 11.7622 20.0236ZM5.50528 12.8138L2.57151 12.8135L2.57151 4.47198H5.50528L5.50528 12.8138Z",
    fill: "inherit"
  }));
};
var _default = exports.default = thumbdown;